<mibi-wall-of-text-layout
    wotTitle="Datenschutzhinweise für Teilnehmer am MiBi-Portal des BfR gemäß Datenschutz-Grundverordnung (DS-GVO)"
>
    <ng-container mibi-wot-preamble>
        Mit den nachfolgenden Informationen geben wir Ihnen einen Überblick über
        die Verarbeitung Ihrer personenbezogenen Daten durch uns im Rahmen
        unseres MiBi-Portals zum Austausch von ans BfR gesendeten Probendaten
        und Ihre Rechte aus dem Datenschutzrecht.
    </ng-container>
    <mibi-datenschutzhinweise mibi-wot-content [model]="datenschutzHinweiseViewModel"></mibi-datenschutzhinweise>
</mibi-wall-of-text-layout>
